import { UserRole } from '../models/user';
import { api } from '../providers/base-api';
import { GetFilterUsersResponse } from '../utils/types/data/services/filters';

export type GetUserFiltersParams = {
  role?: UserRole;
  username?: string;
};

export async function getUserFiltersRequest(
  params?: GetUserFiltersParams,
): Promise<GetFilterUsersResponse[]> {
  const response = await api.get<GetFilterUsersResponse[]>('/filters/users', {
    params,
  });

  return response.data;
}
